import { Fragment } from 'react';
import { Anchor, Box, ShowHide, Text } from '@zillow/constellation-10';

import type { IStyledTextDescriptionModel, IStyledTextModel } from '@rental-manager/models/Types';

type Props = {
  title: string;
  disclaimerContent: Array<IStyledTextModel>;
};

const StyledText = ({ text, url, stylings }: IStyledTextDescriptionModel) => (
  <Text textStyle={stylings?.includes('emphasize') ? 'fineprint-bold' : 'fineprint'} css={{ whiteSpace: 'pre-line' }}>
    {url ? (
      <Anchor href={url} target="_blank" rel="noopener noreferrer">
        {text}
      </Anchor>
    ) : (
      text
    )}
  </Text>
);

const ExpandableDisclaimer = ({ title, disclaimerContent }: Props) => (
  <ShowHide.Root renderButton={() => <ShowHide.Button>{title}</ShowHide.Button>}>
    <Box>
      <ShowHide.Hidden>
        {disclaimerContent?.map((disclaimer, idx) => (
          <Fragment key={disclaimer.header || `disclaimer-${idx}`}>
            <Text
              textStyle="fineprint-bold"
              css={{ display: 'block', marginBlockStart: 'tight', _first: { marginBlockStart: '0' } }}
            >
              {disclaimer.header}
            </Text>
            {disclaimer.description?.map((description, descriptionIdx) => (
              <StyledText key={`${description.text}-${descriptionIdx}`} {...description} />
            ))}
          </Fragment>
        ))}
      </ShowHide.Hidden>
    </Box>
  </ShowHide.Root>
);

export default ExpandableDisclaimer;
